export default __webpack_public_path__ + "static/media/project-1.b173442a.jpg";